export default "__VITE_ASSET__CBjW3PJz__";